import {  useRef, useState, } from 'react'
import { DatePicker, Form, App,   Input, Row, Col, Space, } from 'antd'        
import './report.css'  
import dayjs from 'dayjs';
import { useBaozhangdanAddMutation} from '../../store/DianShangYeWuApi';
import OCRTextArea from '../../cpn/OCRTextArea';    
import ReportOpSelect from './ReportOpSelect';
import Icon from '../../cpn/Icon';
import ReportDeptSelect from '../../system/dept/DeptSelect';
import classes from './report.module.css';
import ClientSelect from '../../system/client/ClientSelect';
import UploadPic from '../../cpn/UploadPic';
import Asterisk from '../../cpn/Asterisk';
import DocumentRule from '../../cpn/DocumentRule';
import ClientContactSelect from '../../system/client/ClientContactSelect';
const {RangePicker} = DatePicker;
function ReportAdd(props) {
    const{message} = App.useApp();
    const qy_id = props.qy_id
    const yh_id = props.yh_id
    const yh_name = props.yh_name
    const qy_name = props.qy_name
    const [form] = Form.useForm();   
    const editForm = useRef()     
    const [info,setInfo] = useState({
        dsbzd_dspt_id:'',//用于对接人
        dsbzd_dspt_name:'',//用于对接人
        dsbzd_kh_id:'',
        dsbzd_kh_name:'',
        dsbzd_jd_id:'',
        dsbzd_jd_name:'',
        dsbzd_zb_id:'',
        dsbzd_zb_name:'',
        dsbzd_dscp_id:'',//用于客户类型
        dsbzd_dscp_name:'',//用于客户类型
        dsbzd_content:'',
        dsbzd_date:'',
        dsbzd_state:'1',    
        dsbzd_date_end:'',
        dsbzd_name:'',
        dsbzd_bm_id:'',
        dsbzd_bm_name:'',
        dsbzd_image_file:'',
        dsbzd_image_name:'',
        dsbzd_khlxr_id:'',//用于客户部门
        dsbzd_khlxr_name:'',//用于客户部门
    })
    const [add] = useBaozhangdanAddMutation()        
    
    return (
        <div style={{width:'100%',height:'100%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center'}}>
            
            <Form
                form={form}
                layout="horizontal"
                name="form_client"
                initialValues={{modifier: 'public',}}
                labelCol={{ span: 3}}
                wrapperCol={{ span: 21 }}   
                variant='filled'
                size='middle'
                ref={editForm}                        
                style={{ maxWidth: 1480,backgroundColor:'#fff',padding:'20px 30px'}}
            >    
                <Row>
                    <Col span={3}></Col>
                    <Col span={18}><div style={{fontSize: '18px', fontWeight: 'bold', textAlign: 'center', marginBottom: '10px'}}>团队报账单</div></Col>
                    <Col span={3}></Col>
                </Row>
                <Row style={{width:"1280px"}}>
                    {/* 第一行 */}
                    <Col span={2} className={classes.col_top_label} style={{borderLeft: '3px solid #000', borderTop: '3px solid #000'}}>
                        <Asterisk color='red'/> 
                        <span>团队名称</span>
                    </Col>
                    <Col span={6}  className={classes.col_top_input} style={{borderTop: '3px solid #000'}}>
                        <Form.Item 
                            name="dsbzd_name" 
                            noStyle
                            rules={[{required: true, message: '请输入团队名称'}]}
                        >
                            <Input 
                                placeholder="请输入团队名称" 
                                style={{ width: '100%' }} 
                                onChange={(e) => {
                                    setInfo(prevState=>({
                                        ...prevState,
                                        dsbzd_name:e.target.value,
                                    }))
                                }}
                            />
                        </Form.Item>
                    </Col>  
                    <Col span={2} className={classes.col_top_label} style={{borderTop: '3px solid #000'}}>
                        <span><Asterisk color='red'/>部门</span>
                    </Col>
                    <Col span={6}  className={classes.col_top_input} style={{borderTop: '3px solid #000'}}>
                        <ReportDeptSelect
                            yh_id={yh_id}          
                            wrapperCol={{span:24}}
                            placeholder='请选择部门'
                            qy_id={qy_id}
                            onChange={(e,f) => {                                                
                                setInfo(prevState=>({...prevState,dsbzd_bm_id:e,dsbzd_bm_name:f}))
                            }}
                            name="dsbzd_bm_name"
                            defaultId={info.dsbzd_bm_id}
                            style={{width: '310px'}}
                            formStyle={{marginBottom: 0,width: '100%'}}
                            list={props.commonList.bm_data}
                        />
                    </Col>  
                    <Col span={2}  className={classes.col_top_label} style={{borderTop: '3px solid #000'}}>收款单</Col>
                    <Col span={6}  className={classes.col_right_input} style={{borderTop: '3px solid #000',borderRight:"3px solid #000"}}>
                        
                    </Col> 
                    {/* 第二行 */}
                    <Col span={2}  className={classes.col_middle_label} style={{borderLeft: '3px solid #000',}}><Asterisk color='red'/> 起止日期</Col>
                    <Col span={6}  className={classes.col_middle_input} style={{padding:'0 5px',justifyContent:'space-between'}}>
                        <Form.Item 
                            name="dsbzd_date" 
                            noStyle
                            rules={[{required: true, message: '请选择开始日期'}]}
                        >
                            <RangePicker 
                                style={{ width: '260px' }} 
                                onChange={(e) => {
                                    setInfo(prevState=>({
                                        ...prevState,
                                        dsbzd_date:dayjs(e[0]).format('YYYY-MM-DD'),
                                        dsbzd_date_end:dayjs(e[1]).format('YYYY-MM-DD'),
                                        dsbzd_month:dayjs(e[0]).format('YYYY-MM'),
                                        dsbzd_year:dayjs(e[0]).format('YYYY'),
                                    }))
                                }}
                            />
                        </Form.Item>
                        {(dayjs(info.dsbzd_date_end).diff(dayjs(info.dsbzd_date), 'day') + 1) > 0 ?  ' 共' + (dayjs(info.dsbzd_date_end).diff(dayjs(info.dsbzd_date), 'day') + 1) + '天 ' : ''}
                    </Col>
                    <Col span={2} className={classes.col_bottom_label}><Asterisk color='red'/>计调</Col>            
                    <Col span={6} className={classes.col_bottom_input}>
                        <ReportOpSelect
                            yh_id={yh_id}          
                            wrapperCol={{span:24}}
                            placeholder='请选择计调'
                            qy_id={qy_id}
                            onChange={(e,f) => {                                                
                                setInfo(prevState=>({...prevState,dsbzd_jd_id:e,dsbzd_jd_name:f}))
                            }}
                            name="dsbzd_jd_name"
                            defaultId={info.dsbzd_jd_id}
                            style={{width: '310px'}}
                            formStyle={{marginBottom: 0,width: '100%'}}
                            list={props.commonList.jd_data}
                        />
                    </Col> 
                    <Col span={2}  className={classes.col_middle_label}>付款单</Col>
                    <Col span={6}  className={classes.col_middle_right_input} style={{borderRight:"3px solid #000"}}>
                        
                    </Col>      
                    {/* 第三行 */}
                    <Col span={2}  className={classes.col_middle_label} style={{borderLeft: '3px solid #000'}}><Asterisk color='red'/> 客户</Col>
                    <Col span={6}  className={classes.col_middle_input} style={{justifyContent:'space-between'}}>
                        <ClientSelect
                            yh_id={yh_id}    
                            yh_name={yh_name}      
                            qy_id={qy_id}
                            qy_name={qy_name}
                            wrapperCol={{span:24}}
                            placeholder='请选择客户'
                            onChange={(e,f,g,h) => {         
                                setInfo(prevState=>({
                                    ...prevState,
                                    dsbzd_kh_id:e || '',
                                    dsbzd_kh_name:f || '',
                                    dsbzd_khlxr_id:'',
                                    dsbzd_khlxr_name:'',
                                    dsbzd_dscp_id:g || '',
                                    dsbzd_dscp_name:h || '',
                                }))
                            }}
                            onClear={() => {
                                setInfo(prevState=>({
                                    ...prevState,
                                    dsbzd_kh_id:'',
                                    dsbzd_kh_name:'',
                                    dsbzd_khlxr_id:'',
                                    dsbzd_khlxr_name:'',
                                    dsbzd_dscp_id:'',
                                    dsbzd_dscp_name:'',
                                }))
                            }}
                            style={{width: '250px'}}
                            clientAdd={true}
                            list={props.commonList.kh_data}
                            name="dsbzd_kh_name"
                            formStyle={{marginBottom: 0}}
                        />
                    </Col>
                    <Col span={2}  className={classes.col_middle_label}>客户部门</Col>
                    <Col span={6}  className={classes.col_middle_input}>                        
                        {info.dsbzd_kh_id &&
                            <ClientContactSelect
                                yh_id={yh_id}    
                                yh_name={yh_name}      
                                qy_id={qy_id}
                                qy_name={qy_name}
                                wrapperCol={{span:24}}
                                placeholder='请选择客户部门'
                                kh_id={info.dsbzd_kh_id}
                                kh_name={info.dsbzd_kh_name}
                                onChange={(e,f) => {                                                
                                    setInfo(prevState=>({...prevState,dsbzd_khlxr_id:e || '',dsbzd_khlxr_name:f || ''}))
                                }}
                                name="dsbzd_khlxr_name"
                                defaultId={info.dsbzd_khlxr_id}
                            />
                        }
                    </Col>
                    <Col span={2}  className={classes.col_middle_label}>毛收入</Col>
                    <Col span={6}  className={classes.col_middle_right_input} style={{borderRight:"3px solid #000"}}>
                        
                    </Col>                        
                    {/* 第四行 */}
                    <Col span={2} className={classes.col_middle_label} style={{borderLeft: '3px solid #000'}}><Asterisk color='red'/> 对接人</Col>
                    <Col span={6}  className={classes.col_middle_input}>
                        <Form.Item name="dsbzd_dspt_name" noStyle>   
                            <Input placeholder='请填写对接人' onChange={(e) => {
                                setInfo(prevState=>({...prevState,dsbzd_dspt_id:e.target.value,dsbzd_dspt_name:e.target.value}))
                            }} style={{width: '100%'}} />
                        </Form.Item>
                    </Col>        
                    <Col span={2}  className={classes.col_middle_label} style={{padding:'10px 5px'}}>备注</Col>
                    <Col span={6}  className={classes.col_middle_input}>
                        <Form.Item name="dsbzd_comments" noStyle>   
                            <OCRTextArea
                                value={info.dsbzd_comments}
                                onChange={(e) => {
                                    setInfo(prevState=>({...prevState,dsbzd_comments:e.target.value}))
                                }}
                                language="chi_sim" 
                            />
                        </Form.Item> 
                    </Col> 
                    <Col span={2}  className={classes.col_middle_label}>费用单</Col>
                    <Col span={6}  className={classes.col_middle_right_input} style={{borderRight:"3px solid #000"}}>                        
                    </Col>       
                    {/* 第五行 */}    
                    <Col span={2} className={classes.col_middle_label} style={{borderLeft: '3px solid #000',borderBottom: '3px solid #000'}}>附件</Col>
                    <Col span={6}  className={classes.col_middle_input} style={{padding:'10px 5px',borderBottom: '3px solid #000'}}>
                        <UploadPic
                            name="dsbzd_image_file"
                            onChange={(e,f) => {
                                console.log(e,f);
                                setInfo(prevState=>({...prevState,dsbzd_image_file:e,dsbzd_image_name:f}))
                            }}
                            maxCount={5}
                            accept="image/*"
                            width="100%"
                            formStyle={{marginBottom: 0,width: '100%'}}
                        />
                    </Col>    
                    <Col span={2}  className={classes.col_middle_label} style={{padding:'10px 5px',borderBottom: '3px solid #000'}}>编号</Col>
                    <Col span={6}  className={classes.col_middle_input} style={{borderBottom: '3px solid #000'}}></Col>  
                    <Col span={2}  className={classes.col_middle_label} style={{borderBottom: '3px solid #000'}}>净收入</Col>
                    <Col span={6}  className={classes.col_middle_right_input} style={{borderRight:"3px solid #000",borderBottom: '3px solid #000'}}>
                    </Col>     
                    {/* 第七行   
                    <Col span={24} className={classes.bottom_row}>
                        <ReportNodeAdd qy_id={props.qy_id} yh_id={props.yh_id} yh_name={props.yh_name} spjdList={props.spjdList}/>
                    </Col>   */}                   
                </Row>  
                <Row>
                    <Col span={24} style={{textAlign: 'right',paddingTop: '10px',display:'flex',justifyContent:'space-between'}}>
                        <DocumentRule/>
                        <Form.Item name="dsbzd_state" noStyle>
                            <Space size={20} >
                                <Icon type='save' onClick={() => {
                                    if(!info.dsbzd_date || !info.dsbzd_date_end || !info.dsbzd_name || !info.dsbzd_jd_id || !info.dsbzd_kh_id || !info.dsbzd_dspt_id || !info.dsbzd_bm_id){
                                        message.error('开始日期、结束日期、团队名称、计调、客户、对接人、部门为必填项目！')
                                        return
                                    }
                                    if(dayjs(info.dsbzd_date).isAfter(dayjs(info.dsbzd_date_end))){
                                        message.error('开始日期不能大于结束日期！')
                                        return
                                    }
                                    add({                        
                                        "dsbzd_content" : info.dsbzd_content,
                                        "dsbzd_date" : info.dsbzd_date,
                                        "dsbzd_dscp_id" : info.dsbzd_dscp_id,
                                        "dsbzd_dscp_name" : info.dsbzd_dscp_name,
                                        "dsbzd_dspt_id" : info.dsbzd_dspt_id,
                                        "dsbzd_dspt_name" : info.dsbzd_dspt_name,
                                        "dsbzd_jd_id" : info.dsbzd_jd_id,
                                        "dsbzd_jd_name" : info.dsbzd_jd_name,
                                        "dsbzd_kh_id" : info.dsbzd_kh_id,
                                        "dsbzd_kh_name" : info.dsbzd_kh_name,
                                        "dsbzd_qy_id" : qy_id,
                                        "dsbzd_qy_name" : qy_name,
                                        "dsbzd_uid" : yh_id,
                                        "dsbzd_uname" : yh_name,
                                        "dsbzd_zb_id" : info.dsbzd_zb_id,
                                        "dsbzd_zb_name" : info.dsbzd_zb_name,
                                        "dsbzd_state" : '1',
                                        "dsbzd_date_end" : info.dsbzd_date_end,
                                        "dsbzd_name" : info.dsbzd_name,
                                        "dsbzd_bm_id" : info.dsbzd_bm_id,
                                        "dsbzd_bm_name" : info.dsbzd_bm_name,
                                        "dsbzd_image_file" : info.dsbzd_image_file?info.dsbzd_image_file:'',
                                        "dsbzd_image_name" : info.dsbzd_image_name?info.dsbzd_image_name:'',
                                        "dsbzd_khlxr_id" : info.dsbzd_khlxr_id,
                                        "dsbzd_khlxr_name" : info.dsbzd_khlxr_name,
                                        'spdd_sp_id': '14',
                                        'spdd_sp_name': '财务管理',
                                        'spdd_spgg_id': '17',
                                        'spdd_spgg_name': '团队报账单',
                                        'spdd_spgg_price': '0.2',
                                        'spdd_state': '支出'
                                    }).then((res) => {
                                        if (res.data.Status === 'success') {                            
                                            message.success('保存成功！')   
                                            form.resetFields();      
                                            setInfo({
                                                dsbzd_dspt_id:'',
                                                dsbzd_dspt_name:'',
                                                dsbzd_kh_id:"",
                                                dsbzd_kh_name:"",
                                                dsbzd_jd_id:'',
                                                dsbzd_jd_name:'',
                                                dsbzd_zb_id:'',
                                                dsbzd_zb_name:'',
                                                dsbzd_dscp_id:'',
                                                dsbzd_dscp_name:'',
                                                dsbzd_content:'',
                                                dsbzd_date:'',
                                                dsbzd_qy_name:'',
                                                dsbzd_state: '1',     
                                                dsbzd_date_end:'',
                                                dsbzd_bm_id:'',
                                                dsbzd_bm_name:'',
                                                dsbzd_image_file:'',
                                                dsbzd_image_name:'',
                                                dsbzd_khlxr_id:'',
                                                dsbzd_khlxr_name:'',
                                            })
                                            // 调用成功回调，传递新记录的 ID
                                            console.log(res.data.Result);
                                            if (props.onSuccess && res.data.Result) {
                                                const newId = res.data.Result.id;
                                                props.onSuccess(newId);
                                            }                                                                   
                                        }
                                        if (res.data.Status === 'fail') {
                                            message.error('保存失败！'+res.data.Message)
                                        }
                                    })  

                                }}>保存</Icon>
                                <Icon type='reset' onClick={() => {
                                    form.resetFields();
                                    setInfo({
                                        dsbzd_name:'',
                                        dsbzd_dspt_id:'',
                                        dsbzd_dspt_name:'',
                                        dsbzd_kh_id:"",
                                        dsbzd_kh_name:"",
                                        dsbzd_jd_id:'',
                                        dsbzd_jd_name:'',
                                        dsbzd_zb_id:'',
                                        dsbzd_zb_name:'',
                                        dsbzd_dscp_id:'',
                                        dsbzd_dscp_name:'',
                                        dsbzd_content:'',
                                        dsbzd_date:'',
                                        dsbzd_qy_name:'',
                                        dsbzd_qy_id:'',
                                        dsbzd_state: '1',
                                        dsbzd_date_end:'',
                                        dsbzd_bm_id:'',
                                        dsbzd_bm_name:'',
                                        dsbzd_image_file:'',
                                        dsbzd_image_name:'',
                                        dsbzd_khlxr_id:'',
                                        dsbzd_khlxr_name:'',
                                    })
                                }}>重置</Icon>
                            </Space>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>           
        </div>
    )
}

export default ReportAdd